<template>
  <div class="faq__questions">
    <div class="faq__questions--wrap">

      <!-- question 1 -->

      <div class="faq__questions--wrap--question faq__questions--wrap--question--1">
        <a @click="showAccordion(0)" class="faq__questions--wrap--question--link">
          {{ $t("faqTranslate.faqQuestions.question1.question") }}
        </a>
        <div :class="{ active: questions[0].show }" class="faq__questions--wrap--question--opener">
          <span></span>
          <span></span>
        </div>
        <p :class="{ active: questions[0].show }" class="faq__questions--wrap--question--body">
          {{ $t("faqTranslate.faqQuestions.question1.answer") }}
        </p>
      </div>

      <!-- question 2 -->

      <div class="faq__questions--wrap--question faq__questions--wrap--question--1">
        <a @click="showAccordion(1)" class="faq__questions--wrap--question--link">
          {{ $t("faqTranslate.faqQuestions.question1.question") }}
        </a>
        <div :class="{ active: questions[1].show }" class="faq__questions--wrap--question--opener">
          <span></span>
          <span></span>
        </div>
        <p :class="{ active: questions[1].show }" class="faq__questions--wrap--question--body">
          {{ $t("faqTranslate.faqQuestions.question1.answer") }}
        </p>
      </div>

      <!-- question 3 -->

      <div class="faq__questions--wrap--question faq__questions--wrap--question--1">
        <a @click="showAccordion(2)" class="faq__questions--wrap--question--link">
          {{ $t("faqTranslate.faqQuestions.question1.question") }}
        </a>
        <div :class="{ active: questions[2].show }" class="faq__questions--wrap--question--opener">
          <span></span>
          <span></span>
        </div>
        <p :class="{ active: questions[2].show }" class="faq__questions--wrap--question--body">
          {{ $t("faqTranslate.faqQuestions.question1.answer") }}
        </p>
      </div>

      <!-- question 4 -->

      <div class="faq__questions--wrap--question faq__questions--wrap--question--1">
        <a @click="showAccordion(3)" class="faq__questions--wrap--question--link">
          {{ $t("faqTranslate.faqQuestions.question1.question") }}
        </a>
        <div :class="{ active: questions[3].show }" class="faq__questions--wrap--question--opener">
          <span></span>
          <span></span>
        </div>
        <p :class="{ active: questions[3].show }" class="faq__questions--wrap--question--body">
          {{ $t("faqTranslate.faqQuestions.question1.answer") }}
        </p>
      </div>

      <!-- question 5 -->

      <div class="faq__questions--wrap--question faq__questions--wrap--question--1">
        <a @click="showAccordion(4)" class="faq__questions--wrap--question--link">
          {{ $t("faqTranslate.faqQuestions.question1.question") }}
        </a>
        <div :class="{ active: questions[4].show }" class="faq__questions--wrap--question--opener">
          <span></span>
          <span></span>
        </div>
        <p :class="{ active: questions[4].show }" class="faq__questions--wrap--question--body">
          {{ $t("faqTranslate.faqQuestions.question1.answer") }}
        </p>
      </div>

      <!-- question 6 -->

      <div class="faq__questions--wrap--question faq__questions--wrap--question--1">
        <a @click="showAccordion(5)" class="faq__questions--wrap--question--link">
          {{ $t("faqTranslate.faqQuestions.question1.question") }}
        </a>
        <div :class="{ active: questions[5].show }" class="faq__questions--wrap--question--opener">
          <span></span>
          <span></span>
        </div>
        <p :class="{ active: questions[5].show }" class="faq__questions--wrap--question--body">
          {{ $t("faqTranslate.faqQuestions.question1.answer") }}
        </p>
      </div>

      <div class="faq__questions--block faq__questions--block--1"></div>
      <div class="faq__questions--block faq__questions--block--2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'faq-questions',
  data () {
    return {
      locale: 'fr',
      questions: [
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false }
      ]
    }
  },
  methods: {
    showAccordion(n) {
      for(var i = 0; i < this.questions.length; i++) {
        this.questions[i].show = false;
      }
      this.questions[n].show = true;
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}
</script>

<style lang="css">
</style>
